import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "trezo-card-subtitle" }
const _hoisted_6 = { class: "trezo-card-dropdown relative" }
const _hoisted_7 = { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }
const _hoisted_8 = {
  key: 0,
  class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "trezo-card-content" }
const _hoisted_11 = {
  key: 0,
  class: "-mt-[10px]",
  style: {"height":"400px"}
}
const _hoisted_12 = {
  key: 1,
  class: "flex justify-center items-center h-[350px]"
}
const _hoisted_13 = { class: "text-gray-500" }
const _hoisted_14 = {
  key: 2,
  class: "flex justify-center items-center h-[350px]"
}
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-gray-500 block" }
const _hoisted_17 = { class: "text-gray-400 text-sm block mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.directT('dashboard.crm.leadsBySource')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block rounded-md border border-gray-100 py-[5px] md:py-[6.5px] px-[12px] md:px-[19px] transition-all hover:bg-gray-50 dark:border-[#172036] dark:hover:bg-[#0a0e19]': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.directT(`dashboard.${_ctx.selectedTimeFilterKey}`)) + " ", 1),
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" }, null, -1))
            ])
          ], 2),
          (_ctx.isActive)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeFilters, (filter) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: filter.key
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black",
                      onClick: ($event: any) => (_ctx.applyTimeFilter(filter.key))
                    }, _toDisplayString(_ctx.directT(`dashboard.${filter.key}`)), 9, _hoisted_9)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (!_ctx.loading && _ctx.sourceData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_ctx.isClient)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 0,
                  type: "donut",
                  height: "350",
                  options: _ctx.leadsBySource,
                  series: _ctx.source
                }, null, 8, ["options", "series"]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.directT('dashboard.crm.loadingData')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-information-line text-4xl text-gray-300 mb-2 block" }, null, -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.directT('dashboard.crm.noLeadsFound')), 1),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.directT('dashboard.crm.noLeadsForPeriod', { period: _ctx.directT(`dashboard.${_ctx.selectedTimeFilterKey}`) })), 1)
              ])
            ]))
    ])
  ]))
}